import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let HomePage = class HomePage extends Vue {
    constructor() {
        super(...arguments);
        //二开开始 逻辑显示卡片
        this.isListshow = true;
        this.isHistoryshow = true;
    }
    mounted() {
        // Mobility Officer可见Mobility Ticket History卡片
        // PA Manager全部可见
        // Facility Suppervisor 可见Facility Ticket History卡片
        // Facility Officer：均不可见
        // 用户名为Admin:全部可见
        let userStr = window.sessionStorage.getItem("user");
        let userR1ole = userStr && JSON.parse(userStr).roleName || "";
        if (userStr && userStr.admin) {
            this.isListshow = true;
            this.isHistoryshow = true;
        }
        else {
            if (userR1ole.indexOf("Mobility Officer") > -1) {
                this.isListshow = false;
                this.isHistoryshow = true;
            }
            else if (userR1ole.indexOf("PA Manager") > -1) {
                this.isListshow = true;
                this.isHistoryshow = true;
            }
            else if (userR1ole.indexOf("Facility Suppervisor") > -1) {
                this.isListshow = false;
                this.isHistoryshow = true;
            }
            else if (userR1ole.indexOf("Facility Officer") > -1) {
                this.isListshow = false;
                this.isHistoryshow = false;
            }
        }
    }
    //二开结束 逻辑显示卡片
    //
    handleClickFacility() {
        this.$router.push('/application/mobility_faclity/application-list/facility?parentId=8a7485f287f96ea30187f98495da10ef&code=facility&openMode&pcUrl&queryCode=&HomePageMessage=');
    }
    handleClickMobility() {
        this.$router.push('/application/mobility_faclity/application-list/mobility_management?parentId=8a7485f287f96ea30187f984d0c710f1&code=mobility_management&openMode&pcUrl&queryCode=&HomePageMessage=');
    }
};
HomePage = tslib_1.__decorate([
    Component({
        name: "HomePage",
        components: {
        //
        },
    })
], HomePage);
export default HomePage;
